exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login-page{max-width:350px;margin:0 auto;padding:30px}.login-page .languages-select{text-align:right}.login-page .desktop-block{padding-top:35px}.login-page .mobile-block{height:45px}.login-page .mobile-block .logo{float:left;width:95px;content-box:border-box}.login-page .mobile-block .heading{padding:9px 10px;font-size:18px;font-weight:700;float:left;color:#fff;position:absolute;margin-left:100px;content-box:border-box}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/guest/resetPassword/styles.less
 ** module id = 597
 ** module chunks = 0
 **/